import React, { useEffect, useReducer } from 'react';
import { LoadScript } from '@react-google-maps/api';
import { Config } from '../../../../types';
import { Loader } from '@strapi/design-system';

const libraries: 'places'[] = ['places'];

// Global state to track if the script is loaded
let isScriptLoaded = false;
let scriptLoadPromise: Promise<void> | null = null;

interface GoogleMapsProviderProps {
    config?: Config;
    children: React.ReactNode;
}

export default function GoogleMapsProvider({ config, children }: GoogleMapsProviderProps) {
    const [scriptLoaded, onScriptLoaded] = useReducer(() => true, false);

    useEffect(() => {
        if (isScriptLoaded) {
            onScriptLoaded();
            return;
        }

        if (!scriptLoadPromise) {
            scriptLoadPromise = new Promise((resolve) => {
                const checkScript = () => {
                    if (window.google?.maps) {
                        isScriptLoaded = true;
                        resolve();
                    } else {
                        setTimeout(checkScript, 100);
                    }
                };
                checkScript();
            });
        }

        scriptLoadPromise.then(() => {
            onScriptLoaded();
        });
    }, []);

    if (!config) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Loader small />
            </div>
        );
    }

    if (!isScriptLoaded) {
        return (
            <>
                <LoadScript
                    googleMapsApiKey={config.googleMapsKey}
                    libraries={libraries}
                    onLoad={() => {
                        isScriptLoaded = true;
                        onScriptLoaded();
                    }}
                />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Loader small />
                </div>
            </>
        );
    }

    return <>{children}</>;
} 